import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import { IoMenu } from "react-icons/io5";
import Image from "next/image";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import { useRouter } from "next/router";
import logo from "../../public/logo.svg";

const pages = [
  { title: "Հաղորդումներ", value: "programs" },
  { title: "Վերլուծություններ", value: "analyses" },
  { title: "Հատուկ Թողարկում", value: "specials" },
  { title: "Իրադարձություններ", value: "events" },
];

function ResponsiveAppBar() {
  const router = useRouter();
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar
      sx={{ backgroundColor: "#fff" }}
      position="fixed"
      className="lg:px-20 xl:px-40 px-4"
      elevation={4}
    >
      <Toolbar>
        <Typography
          variant="h5"
          noWrap
          component="a"
          href="/"
          sx={{
            mr: 2,
            fontFamily: "monospace",
            fontWeight: 700,
            letterSpacing: ".6rem",
            color: "black",
            textDecoration: "none",
            fontSize: "30px",
          }}
        >
          <Image
            width={80}
            height={80}
            sizes="100vh"
            className="absolute top-0"
            src={logo}
            alt="logo"
          />
        </Typography>

        <Box
          sx={{
            flexGrow: 1,
            display: { xs: "none", md: "flex" },
            marginLeft: "140px",
          }}
        >
          {pages.map((page) => (
            <Button
              className="animated-border uppercase"
              key={page.value}
              onClick={() => {
                handleCloseNavMenu();
                router.push(`/${page.value}`);
              }}
              sx={{
                my: 2,
                color:
                  router?.asPath === `/${page.value}` ? "#9b69d4" : "black",
                display: "block",
                textTransform: "none",
                fontSize: "14px",
              }}
            >
              <span>{page.title}</span>
            </Button>
          ))}
        </Box>

        <div className="absolute right-0 block md:hidden">
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleOpenNavMenu}
            color="black"
          >
            <IoMenu />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorElNav}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorElNav)}
            onClose={handleCloseNavMenu}
            sx={{
              display: { xs: "block", md: "none" },
            }}
          >
            {pages.map((page) => (
              <MenuItem
                key={page.value}
                onClick={() => {
                  handleCloseNavMenu();
                  router.push(`/${page.value}`);
                }}
              >
                <Typography
                  sx={{
                    color:
                      router?.asPath === `/${page.value}` ? "#6F4B98" : "clack",
                  }}
                >
                  {page.title}
                </Typography>
              </MenuItem>
            ))}
          </Menu>
        </div>
      </Toolbar>
    </AppBar>
  );
}
export default ResponsiveAppBar;
